export default __webpack_public_path__ + "static/media/safari.b4f7f17f.png";